import { render, staticRenderFns } from "./Bale.vue?vue&type=template&id=0d8d7b94&"
import script from "./Bale.vue?vue&type=script&lang=js&"
export * from "./Bale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports